'use strict';

function JobPostings() {
  this.id = null;
  this.node = null;
  this.initCallback = null;

  this.el = {};
  this._classes = {
    filters: 'js--opening-filters',
    results: 'js--opening-results',
    reset: 'js--reset-form',
    toggle: 'js--section-toggle',
    team: 'js--result-team',
    open: 'job-postings-team--open'
  };

  this.apiUrl = 'https://api.resumatorapi.com/v1/jobs/status/open/confidential/false/private/false?apikey=Z4m2k5hMuav41Hlw7i1mLnsuhOV9VYm5';

  this.init = function () {
    this.$node = $(this.node);
    this.resumatorPromise = this.requestPostings();
    this.lodashPromise = this.loadLodash();

    $.when(this.resumatorPromise, this.lodashPromise).then(this._initPostings.bind(this));
  };

  this.initAllReady = function () {};

  this.requestPostings = function () {
    var _this = this;
    return $.ajax({
      type: 'GET',
      url: this.apiUrl,
      processData: true,
      data: {},
      dataType: 'json',
      error: function error(request, status, _error) {
        _this.displayError();
      }
    });
  };

  this.loadLodash = function () {
    if (typeof _ === 'undefined') {
      return $.ajax({
        url: '//cdnjs.cloudflare.com/ajax/libs/lodash.js/4.17.4/lodash.min.js',
        dataType: 'script',
        cache: false
      });
    }
    return true;
  };

  this.displayError = function () {
    console.log('error');
  };

  this._initPostings = function (resumatorData) {
    this.allJobs = resumatorData[0];
    if (this.allJobs.constructor !== Array) {
      this.allJobs = [this.allJobs];
    }

    this._createForm();
    this._printResults(this.allJobs);

    if (this.initCallback) {
      this.initCallback();
    }
  };

  this._createForm = function () {
    var jobs = this.allJobs;
    var _this = this;
    this.filters = {};

    this.filters.teams = _.uniq(_.map(jobs, 'department'));
    this.filters.types = _.uniq(_.map(jobs, 'type'));
    this.filters.companies = _.uniq(_.map(jobs, 'internal_code'));
    this.filters.locations = _.uniq(_.map(jobs, 'city'));

    var filters = this.filters;


    var $form = $('<form class="job-postings__form">');
    var $filters = Object.keys(filters).map(function (filter) {
      var label = filter.charAt(0).toUpperCase() + filter.slice(1);

      // prettier-ignore
      var $filter = $('' + ('<label class="job-postings__label">' + '<span class="job-postings__label-text a11y__hidden-content">') + label + '</span>' + ('<select class="' + _this._classes.filters + '" value="all" name=' + filter + '>') + ('<option value="all">All ' + label + '</option></select></label>'));

      var $options = filters[filter].map(function (option) {
        return $('<option value="' + option + '">' + option + '</option>');
      });

      $filter.find('.' + _this._classes.filters).append($options).attr('id', 'mogo-select-' + filter).mogo().create('Select');

      return $filter;
    });

    $form.append($filters);
    this.$node.append($form);
    this._handleUpdateForm();
  };

  this._handleResetForm = function () {
    var _this2 = this;

    this.$node.find('.' + this._classes.reset).on('click', function (event) {
      event.preventDefault();
      _this2._resetForm();
    });
  };

  this._resetForm = function () {
    this._printResults(this.allJobs);

    this.$node.find('.' + this._classes.filters).each(function () {
      $(this).mogo().val('all');
    });
  };

  this._handleUpdateForm = function () {
    var _this3 = this;

    this.$node.find('.' + this._classes.filters).on('change', function () {
      _this3._updateResults();
    });
  };

  this._updateResults = function () {
    var jobs = this.allJobs;
    var filters = [];
    this.$node.find('.' + this._classes.filters).each(function () {
      filters[$(this).attr('name')] = $(this).val();
    });

    var filteredJobs = _.filter(jobs, function (job) {
      if (filters.types !== 'all' && job.type !== filters.types) {
        return false;
      }
      if (filters.locations !== 'all' && job.city !== filters.locations) {
        return false;
      }
      if (filters.teams !== 'all' && job.department !== filters.teams) {
        return false;
      }
      if (filters.companies !== 'all' && job.internal_code !== filters.companies) {
        return false;
      }
      return job;
    });

    this._printResults(filteredJobs);
  };

  this._printResults = function (jobs) {
    if (jobs.length <= 0) {
      return this._noResults();
    }

    this.$node.find('.' + this._classes.results).remove();
    var _this = this;

    var jobsByTeam = _.groupBy(jobs, function (job) {
      return job.department;
    });

    var $results = $('<div class="job-postings__results ' + this._classes.results + '">');
    var $resultList = $('<ul class="job-postings-team-list">');
    var $teams = Object.keys(jobsByTeam).map(function (team) {
      // prettier-ignore
      var $team = $('<li class="job-postings-team ' + _this._classes.team + '" data-team-results="' + team + '">' + ('<h3 class="job-postings-team__heading ' + _this._classes.toggle + '">') + ('<span class="job-postings-team__name">' + team + '</span>') + '<span class="job-postings-team__count">' + ('(' + jobsByTeam[team].length + ')') + '</span>' + '<svg class="job-postings-team__toggle svg-icon" viewBox="0 0 32 32"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrowdown"></use></svg>' + '</h3>' + '</li>');
      var $jobList = $('<ul class="job-postings__list"></ul>');
      var $jobs = jobsByTeam[team].map(function (job) {
        var jobUrl = 'https://mogo.applytojob.com/apply/';

        // prettier-ignore
        return $('' + ('<li class="job-postings__list-item">' + '<span class="job-postings__link-container">' + '<a class="job-postings__link" href="') + jobUrl + job.board_code + '" target="_blank">' + job.title + '</a>' + '</span>' + ('<span class="job-postings__type">' + job.type + '</span>') + ('<span class="job-postings__company">' + job.internal_code + '</span>') + ('<span class="job-postings__location">' + job.city + ', ' + job.state + '</span>') + '</li>');
      });

      $jobList.append($jobs);
      $team.append($jobList);

      return $team;
    });

    $resultList.append($teams);
    $results.append($resultList);
    this.$node.append($results);
    this._handleToggleSection();
  };

  this._noResults = function () {
    // prettier-ignore
    var $noResults = $('<div class="job-postings__results ' + this._classes.results + '">' + '<div class="job-postings-no-results">' + '<h3 class="job-postings-no-results__heading">No openings match that selection</h3>' + '<a class="job-postings-no-results-cta marketing__inline-arrow-cta js--reset-form" href="#">View All Open Positions</a>' + '</div>' + '</div>');

    this.$node.find('.' + this._classes.results).remove();
    this.$node.append($noResults);
    this._handleResetForm();
  };

  this._handleToggleSection = function () {
    var _this = this;
    this.$node.find('.' + _this._classes.toggle).on('click', function () {
      _this._toggleSection($(this).parent('.' + _this._classes.team));
    });
  };

  this._toggleSection = function (section) {
    $(section).toggleClass(this._classes.open);
  };
}